import React, { Component } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions/index';

class PopularChart extends Component {
  componentDidMount() {
    this.props.onFetchPopular();
  }

  render() {
    return (
      <ResponsiveContainer width="99%" height="99%">
        <BarChart
          width={500}
          height={300}
          data={this.props.popular}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }}>
          <CartesianGrid />
          <XAxis dataKey="title" hide={true} />
          <YAxis
            domain={[dataMin => Math.abs(dataMin) - 1, dataMax => dataMax + 1]}
            scale={'pow'}
          />
          <Tooltip />
          <Legend />
          <Bar dataKey="rating" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

const mapStateToProps = state => ({
  popular: state.movieReducer.popular
});

const mapDispatchToProps = dispatch => ({
  onFetchPopular: () => dispatch(actions.fetchPopular())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PopularChart);
